/**
 * Функция для генерации ссылки на трекер SmartContact. Более подробная дока доступна здесь:
 * https://onefactor.notion.site/SmartContact-527bbf954137419990210160a7e3c9fe#97334eabd6a94533bdcb76ffd7df7f9c
 *
 * @param pixelId например: 7708279000. Идентификатор заказчика, на сайте которого установлен трэкер, - проставляется ИНН Вашей компании
 * @param eventType например: visit. Тип действия, которое совершил пользователь - определяется типом страницы, на котором установлен трэкер
 * @param product например: my_car. Товар или услуга, описанные на странице, где установлен трэкер
 * @param orderId например low_cost_travel_tickets Номер заказа, оформленный пользователем
 * @returns HTML String
 */
export const generateSmartContactPixelUrl = (
  pixelId: string,
  eventType: 'visit' | 'target_url' | 'registration' | 'application' | 'cart' | 'checkout' | 'purchase',
  product: string,
  orderId?: string,
) => {
  const queryParams = new URLSearchParams();

  queryParams.set('1f_pixel_id', pixelId);
  queryParams.set('event_type', eventType);
  queryParams.set('product', product);
  if (orderId) {
    queryParams.set('order_id', orderId);
  }

  return `https://js.onef.pro/static/reg1f_v1.js?${queryParams.toString()}`;
};
